import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=5fb81842&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=ts"
export * from "./StarRating.vue?vue&type=script&lang=ts"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=5fb81842&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb81842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb81842')) {
      api.createRecord('5fb81842', component.options)
    } else {
      api.reload('5fb81842', component.options)
    }
    module.hot.accept("./StarRating.vue?vue&type=template&id=5fb81842&scoped=true", function () {
      api.rerender('5fb81842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smartMatch/StarRating.vue"
export default component.exports